<template>
    <div class="container">
        <div class="head_card">
            <van-row>
                <van-col span="7" class="avatar">
                    <img src="@/assets/themeThree/male_10.jpg" alt="">
                </van-col>
                <van-col span="17" class="detailsContainer">
                    <div class="notif">
                        <img src="@/assets/themeThree/envelop.png" alt="" @click="onClickCard">
                        <span class="unreadCount" v-if="unreadMsgCount > 0">{{ unreadMsgCount }}</span>
                    </div>
                    <div style="margin-top: -10px;">
                        <div class="contact">{{ $t('profile.id') }} : {{ id }}
                            <img src="@/assets/themeThree/copy-icon.png" alt="" @click="onCopyID(id)">
                            <div class="level">
                                <img src="@/assets/themeThree/level_one.png" alt="">
                            </div>
                        </div>
                        <div class="id">{{ $t('profile.conta') }} : {{ name }}</div>
                        <div class="value">
                            <span style="font-size: 18px;"> {{ formatCurrency(balance) }} R$ </span>
                            <img @click="refreshDetails" src="@/assets/themeThree/refresh.png" alt="">

                        </div>
                    </div>
                </van-col>
                <!-- <van-col span="4" class="mail">
                </van-col> -->
                <van-col span="12" class="withdraw_btn">
                    <PrimaryButton :text="$t('common.sake')" textColor="#fff" bgColor="#2a324e"
                        :icon="require('@/assets/themeThree/withdraw.png')" @onClick="onButtonClick('withdraw')" />
                </van-col>
                <van-col span="12" class="deposit_btn">
                    <PrimaryButton :text="$t('common.deposite')" textColor="#fff" bgColor="#17af5f"
                        :icon="require('@/assets/themeThree/deposit.png')" @onClick="onButtonClick('topup')" />
                </van-col>
            </van-row>
        </div>

        <StatusPopup ref="statusRef" :content="$t('common.copied')" :isShowSuccess="true" />
        <CarteiraView ref="walletPopupRef" />
        <LoadingScreen ref="loadingRef" />
    </div>
</template>

<script setup lang="ts">
import PrimaryButton from '../../components/common/primaryButton.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useUserStore } from '@/stores/user';
import { formatCurrency } from '@/utils/commonFunction';
import CarteiraView from '@/view/carteiraView/carteiraView.vue';
import { buttonClick, clickOnCard, copyID } from '@/view/profile/supportScript';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter()
const statusRef = ref();
const userStore = useUserStore()
const name = computed(() => userStore.nickname)
const balance = computed(() => userStore.balance)
const id = computed(() => userStore.id)
const unreadMsgCount = computed(() => userStore.unreadCount)
const isPopping = ref(false)
const walletPopupRef = ref()
const loadingRef = ref()

const onClickCard = () => clickOnCard(router, isPopping, '/sd-message')
const onCopyID = (id: any) => copyID(statusRef, id)
const onButtonClick = (type: string) => {
    if (type === 'withdraw') {
        router.push({ path: '/sd-withdraw' });
    } else if (type === 'topup') {
        router.push({ path: '/sd-topup' });
        localStorage.setItem('showDepositBackIcon', '1')
    }
}

async function refreshDetails() {
    try {
        loadingRef.value.open()
        await userStore.getInfo()
    } catch (e) {
        console.log(e);
    } finally {
        loadingRef.value.close()
    }
}
</script>
<style scoped>
.container {
    padding: 20px 10px;
    font-size: 13px;
    ;
    background: #161d30;
    border-radius: 10px;
}

.head_card img {
    width: 100%;
}

.avatar img {
    width: 100px;
    border-radius: 10px;
    border: .02667rem solid hsla(0, 0%, 100%, .25);
}

.value img {
    width: 25px;
    padding-left: 10px;
}


.notif {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
}

.notif img {
    width: 25px;
}

.unreadCount {
    color: #fff;
    background: red;
    border-radius: 10px;
    width: 15px;
    height: 15px;
    font-size: 12px;
    text-align: center;
    position: absolute;
    bottom: 15px;
    right: -8px;
}

@media (max-width:450px) {
    .content {
        margin: -39vw 0 1vh 0;
        padding: 0 15px;
    }
}

@media (min-width: 500px) {
    .content {
        margin: -22vh 0 6vh 0;
        padding: 0 15px;
        font-size: 2.1vh;
    }

    .head_card {
        /* padding: 1vw; */
        padding-bottom: 0;
    }

    .button_container {
        font-size: 2.1vh;
    }
}

@media (min-width: 1440px) {
    .content {
        margin: -11vw 0 3vh 0;
        padding: 0 15px;
        font-size: 1vw;
    }

    .button_container {
        font-size: 1vw;
    }
}

@media (min-width: 1920px) {
    .content {
        margin: -9vw 0 6vh 0;
        padding: 0 15px;
        font-size: 1vw;
    }

    .head_card {
        /* padding: 1vw; */
        padding-bottom: 0;
    }

    .button_container {
        font-size: 1vw;
    }
}

.mail {
    display: flex;
    justify-content: right;
}

.mail img {
    width: 30px;
    height: 32px;
}

.id {
    color: #fff;
    display: flex;
    /* font-size: 15px; */
    align-items: center;
    flex-direction: row;
    margin-bottom: 6px
}

.detailsContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 10px;
    font-size: 16px;
}

@media (max-width:380px) {
    .detailsContainer {
        padding-left: 20px;
        font-size: 14px;

    }

    .value img {
        width: 20px;
    }

    .value {
        font-size: 15px;

    }
}

.contact {
    color: #fff;
    /* font-size: 15px; */
    align-items: center;
    display: flex;
}

.contact img {
    width: 25px;
    padding: 0px;
}

.level img {
    width: 50px;
    padding-left: 5px;
}

.value {
    color: rgba(255, 255, 255, 0.65);
    font-size: 18px;

}

.value span {
    color: #fff;
    font-size: 14.25px;
    /* font-weight: bold; */
}

.withdraw_btn {
    margin-top: 10px;
    padding: 5px;
}

.deposit_btn {
    margin-top: 10px;
    padding: 5px;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.75);
    }

    100% {
        transform: scale(1);
    }
}
</style>